import React, {Component, useEffect, useState} from 'react';
import {app} from "app/app";
import 'assets/sass/login/Login.scss';
import {images} from "assets/img/common/common";
import { Link } from 'react-router-dom';

const ConfirmAccountController = ({history}) => {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        if(/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)){
            setIsMobile(true);
        }
    });

    const goToDownloadApp = () => {
        window.location = 'https://buenbit.onelink.me/A1PW/55a3c7e9';
    };

    const content = <div className="verification-email-landing">
        <div className={`verification-email-landing-container ${!isMobile && 'verification-email-desktop'}`}>
            <img className="verification-email-logo" src={images.logo} alt={app.productName()}/>
            <div style={{paddingBottom: '24px'}} className="verification-email-landing-container-box">
                <img className="verification-email-check" src={images.circleCheck} alt={app.productName()}/>
                <h2>Necesitamos que te verifiques</h2>
                <p>Escaneá el código QR para continuar desde la app de Buenbit</p>
                {
                isMobile
                ?   <div className="verification-email-button">
                        <button className={`cta-button`}
                            onClick={() => goToDownloadApp()}>
                        Descargar app
                        </button>
                    </div>
                :   <div className="verification-email-qr">
                        <img src={images.qrStores} alt={app.productName()}/>
                        <Link style={{textDecoration: 'underline', marginBottom: '24px', color: '#00317a'}} to={app.routes().index}>Ahora no</Link>
                    </div>
                }
            </div>
        </div>
    </div>;

    return content;
};

export default ConfirmAccountController;

